import CIcon from '@coreui/icons-react';
import { CCol, CFormGroup, CImg, CRow } from '@coreui/react';
import _ from 'lodash';
import { runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Component } from 'react';
import { v4 as generateRandomId } from 'uuid';

import { returnClientApiUrl } from '../../core/Api/instance';
import { OrmStoreType } from '../../core/Stores/DirectoryStore';
import { OrmUserStoreType } from '../../core/Stores/OrmUserStore';
import NatHierarchicalList from '../../shared/Components/NatHierarchicalList';
import NatListContainer from '../../shared/Components/NatListContainer';
import { listDateTimeFormatter } from '../../shared/Formatters/ListDateTimeFormatter';
import { relationFormatter } from '../../shared/Formatters/RelationFormatter';
import { stringFormatter } from '../../shared/Formatters/StringFormatter';
import NatRelationInput from '../../shared/Inputs/NatRelationInput';
import NatValueInput from '../../shared/Inputs/NatValueInput';
import { catalog } from '../../shared/support/Catalog';
import { FormContainerPropsType } from '../../shared/support/modelTypes';
import { ProductsListStoreType } from './ProductsListStore';

interface PropsType extends FormContainerPropsType<ProductsListStoreType> {}

interface StateType {}

interface InjectedProps extends PropsType {
	directoryStore: OrmStoreType;
	userStore: OrmUserStoreType;
}

@inject('directoryStore', 'userStore')
@observer
class ProductsListContainer extends Component<PropsType, StateType> {
	constructor(props: PropsType) {
		super(props);
		this.resetSearchFields = this.resetSearchFields.bind(this);
		this.createFilter = this.createFilter.bind(this);
	}
	get injected() {
		return this.props as InjectedProps;
	}
	createFilter() {
		// if (!_.isEmpty(productsSearchFields.name)) {
		// 	or = [
		// 		{
		// 			name: {
		// 				like: productsSearchFields.name,
		// 				options: 'i'
		// 			}
		// 		}
		// 	];
		// 	filter.where.or = or;
		// }
	}
	resetSearchFields() {
		runInAction(() => {
			this.props.store.searchFields = {
				deleted: false
			};
			this.props.store.chipsFields = {
				name: {
					id: null,
					chips: [],
					title: 'Наименование',
					isLocalizedString: true
				},
				article: {
					id: null,
					chips: [],
					title: 'Артикул'
				},
				description: {
					id: null,
					chips: [],
					title: 'Описание'
				},
				createdAtGt: {
					isDate: true,
					id: null,
					chips: [],
					isGt: true
				},
				createdAtLt: {
					isDate: true,
					id: null,
					chips: [],
					isGt: false
				},
				deleted: {
					id: false,
					display: { isChecked: false, title: 'Отображать' },
					doNotDisplay: { isChecked: true, title: 'Не отображать' },
					chips: [
						{
							id: generateRandomId(),
							name: {
								ru: 'Удаленные: не отображать'
							}
						}
					],
					isBoolean: true,
					title: 'Удаленные'
				}
			};
		});
	}
	render() {
		return (
			<NatListContainer
				store={this.props.store}
				createFilter={this.createFilter}
				resetSearchFields={this.resetSearchFields}
				defaultFilterWhere={{ deleted: false, elementType: 0 }}
				hierarchical
				navigationRoute={this.props.navigationRoute}
				index={this.props.index}>
				{(childrenProps) => (
					<NatHierarchicalList
						name="products"
						store={this.props.store}
						navigationRoute={this.props.navigationRoute}
						goTo={this.props.goTo}
						childrenProps={childrenProps}
						addButtonTitle="Добавить номенклатуру"
						editingFields={
							<CRow>
								<CCol lg="12">
									<CFormGroup row className="mb-0">
										<CCol md="4">
											<NatRelationInput
												object={this.props.store.bulkEditingFields}
												property="parentId"
												relation="parent"
												placeholder="Выберите группу"
												type="text"
												size="sm"
												formatter={relationFormatter()}
												pluralName="products"
												filterWhere={{ deleted: false, elementType: 1 }}
												autoComplete="off"
												label="Группа"
												mobile
												treeSelect
												goTo={this.props.goTo}
											/>
										</CCol>
									</CFormGroup>
								</CCol>
							</CRow>
						}
						columns={[
							{
								id: 'checkbox',
								pinned: true,
								className: '',
								width: '54px',
								minResizeWidth: 0,
								maxResizeWidth: null,
								resizable: false,
								visible: true,
								headerCellRenderer: () => {
									return <div></div>;
								},
								cellRenderer: ({ onChange, value }: { onChange: any; value: any }) => {
									return (
										<div className="rgt-cell-inner ml-0 mr-0">
											<input type="checkbox" id="checkbox" onChange={onChange} checked={value} />
										</div>
									);
								}
							},
							{
								id: 1,
								field: 'deleted',
								label: '',
								width: '70px',
								cellRenderer: ({ data }: { data: any }) => {
									return <div className="rgt-cell-inner">{<CIcon src={catalog.pickupCatalogStateImage(data)} size="lg" />}</div>;
								},
								sort: () => {}
							},
							{
								id: 2,
								field: 'primaryImageId',
								label: '',
								width: '70px',
								cellRenderer: ({ data }: { data: any }) => {
									return (
										<div
											className={(() => {
												if (data.deleted) {
													return 'rgt-cell-inner rgt-text-truncate text-secondary';
												} else {
													return 'rgt-cell-inner rgt-text-truncate';
												}
											})()}>
											{(() => {
												if (!_.isEmpty(data.primaryImageId)) {
													let src: string = returnClientApiUrl() + `/files/${data.primaryImageId}/size/thumbnail/download`;
													if (this.injected.directoryStore.models.apiData.mode === 'tenant') {
														src = src + `?tenantClientId=${localStorage.getItem('tenantClientId')}`;
													}
													return <CImg src={src} width="35" height="30" />;
												} else {
													return null;
												}
											})()}
										</div>
									);
								},
								sort: () => {}
							},
							{
								id: 3,
								field: 'createdAt',
								label: 'Дата создания',
								cellRenderer: ({ data }: { data: any }) => {
									return (
										<div
											className={(() => {
												if (data.deleted) {
													return 'rgt-cell-inner rgt-text-truncate text-secondary';
												} else {
													return 'rgt-cell-inner rgt-text-truncate';
												}
											})()}>
											{listDateTimeFormatter.renderValue(data.createdAt)}
										</div>
									);
								},
								sort: () => {}
							},
							{
								id: 4,
								field: 'name',
								label: 'Имя',
								cellRenderer: ({ data }: { data: any }) => {
									return (
										<div
											className={(() => {
												if (data.deleted) {
													return 'rgt-cell-inner rgt-text-truncate text-secondary';
												} else {
													return 'rgt-cell-inner rgt-text-truncate';
												}
											})()}>
											{catalog.renderCatalogName(data)}
										</div>
									);
								},
								sort: () => {}
							},
							{
								id: 5,
								field: 'article',
								label: 'Артикул',
								width: '120px',
								cellRenderer: ({ data }: { data: any }) => {
									return (
										<div
											className={(() => {
												if (data.deleted) {
													return 'rgt-cell-inner rgt-text-truncate text-secondary';
												} else {
													return 'rgt-cell-inner rgt-text-truncate';
												}
											})()}>
											{data.article}
										</div>
									);
								},
								sort: () => {}
							},
							{
								id: 6,
								field: 'description',
								label: 'Описание',
								width: '120px',
								cellRenderer: ({ data }: { data: any }) => {
									return (
										<div
											className={(() => {
												if (data.deleted) {
													return 'rgt-cell-inner rgt-text-truncate text-secondary';
												} else {
													return 'rgt-cell-inner rgt-text-truncate';
												}
											})()}>
											{!_.isEmpty(data.description) ? data.description[this.injected.directoryStore.models.language] : ''}
										</div>
									);
								},
								sort: () => {}
							}
						]}>
						<>
							<NatValueInput<string> object={this.props.store.chipsFields.article} property="id" placeholder="Введите артикул" type="text" formatter={stringFormatter()} size="sm" autoComplete="off" label="Артикул" />
							<NatValueInput<string> object={this.props.store.chipsFields.description} property="id" placeholder="Введите описание" type="text" formatter={stringFormatter()} size="sm" autoComplete="off" label="Описание" />
						</>
					</NatHierarchicalList>
				)}
			</NatListContainer>
		);
	}
}

export default ProductsListContainer;
